import { ProjectTask, TeamMemberProfile } from '../types';

export const DEFAULT_TEAM_MEMBERS: TeamMemberProfile[] = [
  { id: 'tm-1', name: 'Vishal', role: 'Design & Electrical Engineer', email: 'vishal@dvepl.com', phone: '+91 98765 43210', department: 'Engineering', specialization: 'Design Incharge', active: true },
  { id: 'tm-2', name: 'Akshay', role: 'Senior Drawing & Project Engineer', email: 'akshay@dvepl.com', phone: '+91 98765 43211', department: 'Engineering & CAD', specialization: 'Drawings Incharge', active: true },
  { id: 'tm-3', name: 'Arun', role: 'Production & Site Engineer', email: 'arun@dvepl.com', phone: '+91 98765 43212', department: 'Manufacturing & Workshop', specialization: 'Production Incharge', active: true },
  { id: 'tm-4', name: 'Deepanshu', role: 'Procurement & PO Incharge', email: 'deepanshu@dvepl.com', phone: '+91 98765 43216', department: 'Purchase & Supply Chain', specialization: 'PO Incharge', active: true },
  { id: 'tm-5', name: 'Shobhit', role: 'HT Panels & Nesting Specialist', email: 'shobhit@dvepl.com', phone: '+91 98765 43214', department: 'Manufacturing', specialization: 'Production Incharge', active: true },
  { id: 'tm-6', name: 'Lakhwinder', role: 'Testing & Quality Head', email: 'lakhwinder@dvepl.com', phone: '+91 98765 43213', department: 'Testing & QA', specialization: 'Testing & Quality', active: true },
  { id: 'tm-7', name: 'Prerna', role: 'Accounts & Payment Followups', email: 'prerna@dvepl.com', phone: '+91 98765 43217', department: 'Commercial & Accounts', specialization: 'Commercial & Management', active: true },
  { id: 'tm-8', name: 'Ankit', role: 'VCB & Switchgear Engineer', email: 'ankit@dvepl.com', phone: '+91 98765 43215', department: 'Engineering', specialization: 'Design Incharge', active: true },
  { id: 'tm-9', name: 'Dinesh Sir', role: 'Managing Director & Commercial Head', email: 'dinesh@dvepl.com', phone: '+91 98111 00001', department: 'Executive Management', specialization: 'Commercial & Management', active: true },
  { id: 'tm-10', name: 'Iqbal Sir', role: 'Technical Director', email: 'iqbal@dvepl.com', phone: '+91 98111 00002', department: 'Technical Direction', specialization: 'Design Incharge', active: true },
  { id: 'tm-11', name: 'Simran', role: 'Order Coordination & Followup', email: 'simran@dvepl.com', phone: '+91 98111 00005', department: 'Coordination', specialization: 'General', active: true }
];

export const TEAM_MEMBERS = DEFAULT_TEAM_MEMBERS;

export const ORDER_MANAGERS = [
  'DINESH SIR',
  'IQBAL SIR',
  'PRERNA',
  'DEEPANSHU',
  'ARUN',
  'SIMRAN',
  'ANKIT'
];

export const VENDORS = [
  { name: 'Havells', email: 'switchgear.orders@havells.com', contact: 'Sumeet Dubey' },
  { name: 'Lauritz Knudsen (LK / L&T)', email: 'orders@lauritzknudsen.com', contact: 'Sumit Chinouria / Dushant' },
  { name: 'HPL Electric', email: 'delhi.sales@hplindia.com', contact: 'Navjot Singh' },
  { name: 'IndoAsian', email: 'support@indoasian.com', contact: 'Vishal Sandhu' },
  { name: 'Benlo', email: 'orders@benloelectric.com', contact: 'Sandeep Mehta' },
  { name: 'Schneider Electric', email: 'orders.india@se.com', contact: 'Mohd Yameen' },
  { name: 'Unikon Transformers', email: 'sales@unikon.in', contact: 'Ujjwal' },
  { name: 'BS Electrical Delhi', email: 'bselectrical.delhi@gmail.com', contact: 'B.S. Rep' },
  { name: 'ABB India', email: 'contact.abb@in.abb.com', contact: 'Ritik Sir' }
];

export const INITIAL_PROJECTS: ProjectTask[] = [
  {
    id: 'proj-7906',
    sNo: '7906',
    dveplCode: '7906',
    orderConfirmDate: '2026-04-01',
    orderTakenBy: 'DINESH SIR',
    deliveryTarget: 'June 2026',
    concernedPerson: 'Vishal (Design), Akshay (Drawing), Deepanshu (PO), Arun (Cutting), Prerna (Payment)',
    concernedPersons: ['Vishal', 'Akshay', 'Deepanshu', 'Arun', 'Prerna'],
    projectRoleAssignments: [
      { role: 'Drawing Incharge', person: 'Akshay' },
      { role: 'PO incharge', person: 'Deepanshu' },
      { role: 'Design Incharge', person: 'Vishal' },
      { role: 'Direct production - Manual Cutting', person: 'Arun' },
      { role: 'Payment Followups', person: 'Prerna' }
    ],
    concernedEmail: 'vishal@dvepl.com',
    partyName: 'ONKAR NATH BHALLA',
    partyEmail: 'onkar.bhalla@engineeringprojects.in',
    caNumber: 'CEPZ-10_2025-26',
    itemDescription: 'SR-NO 189 (1 Nos), SRNO-177 (30 Nos), SRNO-190 (2 Nos) - Spreader Terminal Kit 4P',
    items: [
      {
        id: 'item-7906-1',
        itemNumber: 'SRNO-189',
        name: 'Spreader Terminal Kit 4P 80A-100A',
        qty: 1,
        unit: 'Nos',
        unitPrice: 45000,
        totalPrice: 45000,
        specifications: '4 Pole, 80A-100A heavy duty, silver plated terminals'
      },
      {
        id: 'item-7906-2',
        itemNumber: 'SRNO-177',
        name: '63A 4P 10KA MCCB Module Panel Feeder',
        qty: 30,
        unit: 'Nos',
        unitPrice: 3500,
        totalPrice: 105000,
        specifications: '63A 4P 10kA Ics=Icu thermal-magnetic trip'
      },
      {
        id: 'item-7906-3',
        itemNumber: 'SRNO-190',
        name: 'Auxiliary Shunt Release & Control Spreaders',
        qty: 2,
        unit: 'Nos',
        unitPrice: 12500,
        totalPrice: 25000,
        specifications: '230VAC shunt release kit with auxiliary contacts'
      }
    ],
    amount: 175000,
    gst: 31500,
    totalAmount: 206500,
    advance: 0,
    balance: 206500,
    stage: 'Drawing Approval Pending',
    priority: 'Critical',
    materialStatus: '63A 4P 10KA MCCB - 2PC, Spreader terminal kit 4 pole 80A-100A',
    vendorName: 'Havells',
    vendorEmail: 'switchgear.orders@havells.com',
    poNumber: '5464',
    poAmount: 27227,
    vendorPOs: [
      {
        id: 'po-7906-1',
        vendorName: 'Havells',
        category: 'Switchgear (MCCBs & Contactors)',
        concernedPerson: 'Sumeet Dubey',
        mobileNo: '+91 98112 34567',
        emailId: 'switchgear.orders@havells.com',
        poNumber: '5464',
        poDate: '16/04/2026',
        amountWithoutGst: 27227,
        gstRate: 18,
        gstAmount: 4901,
        amountWithGst: 32128,
        materialStatus: 'Delivered at Plant - 63A 4P 10kA MCCBs (2 Nos)'
      },
      {
        id: 'po-7906-2',
        vendorName: 'Schneider Electric',
        category: 'Shunt Releases & Spreader Terminal Kits',
        concernedPerson: 'Mohd Yameen',
        mobileNo: '+91 98711 54321',
        emailId: 'orders.india@se.com',
        poNumber: '5465',
        poDate: '18/04/2026',
        amountWithoutGst: 25000,
        gstRate: 18,
        gstAmount: 4500,
        amountWithGst: 29500,
        materialStatus: 'Partially Received (Awaiting 1 set of spreaders)'
      },
      {
        id: 'po-7906-3',
        vendorName: 'IndoAsian',
        category: 'Busbar Hardware & Enclosure Accessories',
        concernedPerson: 'Vishal Sandhu',
        mobileNo: '+91 99990 12345',
        emailId: 'support@indoasian.com',
        poNumber: '5466',
        poDate: '20/04/2026',
        amountWithoutGst: 15400,
        gstRate: 18,
        gstAmount: 2772,
        amountWithGst: 18172,
        materialStatus: 'Dispatched via SafeXpress LR #7829'
      }
    ],
    drawingSendDate: '2026-04-15',
    drawingApprovedDate: '',
    remark: 'Reminder 12 sent on 08-09-26. Client verbal reminder given, urgent signoff needed.',
    followUpCount: 12,
    lastFollowUpDate: '2026-09-08',
    nextFollowUpDate: '2026-09-19',
    autoFollowUpEnabled: true,
    followUpCadenceDays: 2,
    followUpHistory: [
      {
        id: 'fu-7906-12',
        date: '2026-09-08',
        type: 'drawing_approval',
        recipientEmail: 'onkar.bhalla@engineeringprojects.in',
        recipientName: 'Onkar Nath Bhalla',
        subject: 'URGENT: Reminder #12 - Pending Drawing Approval for CEPZ-10_2025-26 (DVEPL-7906)',
        body: 'Dear Sir, Regarding CEPZ-10_2025-26 panels, drawings submitted on 15/4/26 remain pending for approval. Kindly expedite to avoid delivery slippage.',
        status: 'sent',
        reminderNumber: 12,
        deliveryMethod: 'smtp'
      }
    ],
    milestones: [
      { id: 'm1', title: 'Drawing Preparation', completed: true, completedAt: '2026-04-14', assignedTo: 'Vishal' },
      { id: 'm2', title: 'Drawing Sent to Party', completed: true, completedAt: '2026-04-15', assignedTo: 'Vishal' },
      { id: 'm3', title: 'Drawing Approval from Client', completed: false, assignedTo: 'Vishal' },
      { id: 'm4', title: 'Component PO Placement', completed: true, completedAt: '2026-04-16', assignedTo: 'Dinesh Sir' },
      { id: 'm5', title: 'Fabrication & Powder Coating', completed: false, assignedTo: 'Arun' },
      { id: 'm6', title: 'Wiring & Assembly', completed: false, assignedTo: 'Vishal' },
      { id: 'm7', title: 'Final Testing & Dispatch', completed: false, assignedTo: 'Lakhwinder' }
    ],
    createdAt: '2026-04-01T10:00:00Z',
    updatedAt: '2026-09-18T14:30:00Z'
  },
  {
    id: 'proj-7898',
    sNo: '7898',
    dveplCode: '7898',
    orderConfirmDate: '2026-04-01',
    orderTakenBy: 'DINESH SIR',
    deliveryTarget: 'June 2026',
    concernedPerson: 'Vishal (Design), Akshay (Drawing), Arun (Cutting)',
    concernedPersons: ['Vishal', 'Akshay', 'Arun'],
    projectRoleAssignments: [
      { role: 'Drawing Incharge', person: 'Akshay' },
      { role: 'Design Incharge', person: 'Vishal' },
      { role: 'Direct production - Manual Cutting', person: 'Arun' }
    ],
    concernedEmail: 'vishal@dvepl.com',
    partyName: 'ONKAR NATH BHALLA',
    partyEmail: 'onkar.bhalla@engineeringprojects.in',
    caNumber: 'CEPZ-10_2025-26',
    itemDescription: 'LT PANEL - SRNO-82 (8 Nos), SRNO-84 (6 Nos), SRNO-97 (163 Nos)',
    items: [
      {
        id: 'item-7898-1',
        itemNumber: 'SRNO-82',
        name: 'LT Panel Main Incomer Section (100A 4P 36kA)',
        qty: 8,
        unit: 'Nos',
        unitPrice: 42000,
        totalPrice: 336000,
        specifications: '100A 4P 36kA MCCB, Form 4b execution with digital metering'
      },
      {
        id: 'item-7898-2',
        itemNumber: 'SRNO-84',
        name: 'AC3:65A AC1:85A 3P Power Contactor Panel Feeder',
        qty: 6,
        unit: 'Nos',
        unitPrice: 24500,
        totalPrice: 147000,
        specifications: '3P Power contactor 65A AC3 with thermal overload relay'
      },
      {
        id: 'item-7898-3',
        itemNumber: 'SRNO-97',
        name: 'Sub-distribution Feeder Breaker Kits',
        qty: 163,
        unit: 'Nos',
        unitPrice: 2012.27,
        totalPrice: 328000,
        specifications: 'Terminal kits & din rail miniature circuit breaker modules'
      }
    ],
    amount: 811000,
    gst: 145980,
    totalAmount: 956980,
    advance: 0,
    balance: 956980,
    stage: 'Drawing Approval Pending',
    priority: 'Critical',
    materialStatus: '100A 4P 36 KA MCCB - 8PC, AC3:65A AC1: 85A 3P Power Contactor',
    vendorName: 'Havells',
    vendorEmail: 'switchgear.orders@havells.com',
    poNumber: '5464',
    poAmount: 87789,
    drawingSendDate: '2026-04-15',
    remark: 'Reminder 12 done on 09-08-26 yet pending. Component PO placed with Havells & Legrand.',
    followUpCount: 12,
    lastFollowUpDate: '2026-08-09',
    nextFollowUpDate: '2026-09-19',
    autoFollowUpEnabled: true,
    followUpCadenceDays: 3,
    followUpHistory: [
      {
        id: 'fu-7898-12',
        date: '2026-08-09',
        type: 'drawing_approval',
        recipientEmail: 'onkar.bhalla@engineeringprojects.in',
        recipientName: 'Onkar Nath Bhalla',
        subject: 'Reminder #12: LT Panel Drawing Approval Pending - Ref DVEPL-7898',
        body: 'Follow-up regarding approval of submitted drawing for LT Panel.',
        status: 'sent',
        reminderNumber: 12,
        deliveryMethod: 'smtp'
      }
    ],
    milestones: [
      { id: 'm1', title: 'Drawing Preparation', completed: true, completedAt: '2026-04-14', assignedTo: 'Vishal' },
      { id: 'm2', title: 'Drawing Sent to Party', completed: true, completedAt: '2026-04-15', assignedTo: 'Vishal' },
      { id: 'm3', title: 'Drawing Approval from Client', completed: false, assignedTo: 'Vishal' },
      { id: 'm4', title: 'Component PO Placement', completed: true, completedAt: '2026-04-16', assignedTo: 'Dinesh Sir' },
      { id: 'm5', title: 'Fabrication & Powder Coating', completed: false, assignedTo: 'Arun' },
      { id: 'm6', title: 'Assembly & Dispatch', completed: false, assignedTo: 'Lakhwinder' }
    ],
    createdAt: '2026-04-01T11:00:00Z',
    updatedAt: '2026-09-15T09:00:00Z'
  },
  {
    id: 'proj-7427',
    sNo: '7427',
    dveplCode: '7427',
    orderConfirmDate: '2026-03-02',
    orderTakenBy: 'DINESH SIR',
    deliveryTarget: 'May 2026',
    concernedPerson: 'Vishal',
    concernedEmail: 'vishal@dvepl.com',
    partyName: 'ONBS',
    partyEmail: 'purchase@onbs-projects.com',
    caNumber: 'CEPZ-01-2025-26',
    itemDescription: 'Item 31 (1 No), Item 52 (1 No), Item 25 (4 Nos) LT Panels',
    items: [
      {
        id: 'item-7427-1',
        itemNumber: 'Item 31',
        name: 'Main LT Incomer Panel with Microprocessor Trip',
        qty: 1,
        unit: 'Nos',
        unitPrice: 450000,
        totalPrice: 450000,
        specifications: '1600A 4P 50kA Air Circuit Breaker, drawout type with bus coupler'
      },
      {
        id: 'item-7427-2',
        itemNumber: 'Item 52',
        name: 'Automatic Power Factor Correction (APFC) Panel 250kVAR',
        qty: 1,
        unit: 'Nos',
        unitPrice: 535000,
        totalPrice: 535000,
        specifications: 'Heavy duty MPP capacitors with 7% detuned reactors and 16-stage controller'
      },
      {
        id: 'item-7427-3',
        itemNumber: 'Item 25',
        name: 'Floor Standing Sub-Distribution Feeder Pillar Panels',
        qty: 4,
        unit: 'Nos',
        unitPrice: 150000,
        totalPrice: 600000,
        specifications: 'Outdoor IP55 weather-proof canopy enclosures with 250A MCCBs'
      }
    ],
    amount: 1585000,
    gst: 285300,
    totalAmount: 1870300,
    advance: 0,
    balance: 1870300,
    stage: 'Drawing Approval Pending',
    priority: 'High',
    materialStatus: 'LK PO 5453: MCCB 200AMP 4P 50 KA - 1PC PENDING. Havells PO 5448 received.',
    vendorName: 'Lauritz Knudsen (LK / L&T)',
    vendorEmail: 'orders@lauritzknudsen.com',
    poNumber: '5453',
    poAmount: 298591,
    drawingSendDate: '2026-03-05',
    remark: 'Reminder 9 sent on 08-08-26. Material LK pending 1pc.',
    followUpCount: 9,
    lastFollowUpDate: '2026-08-08',
    nextFollowUpDate: '2026-09-20',
    autoFollowUpEnabled: true,
    followUpCadenceDays: 4,
    followUpHistory: [],
    milestones: [
      { id: 'm1', title: 'Drawing Sent', completed: true, completedAt: '2026-03-05', assignedTo: 'Vishal' },
      { id: 'm2', title: 'Drawing Approval', completed: false, assignedTo: 'Vishal' },
      { id: 'm3', title: 'Material Procurement', completed: true, completedAt: '2026-03-30', assignedTo: 'Dinesh Sir' },
      { id: 'm4', title: 'Production & Wiring', completed: false, assignedTo: 'Arun' }
    ],
    createdAt: '2026-03-02T10:00:00Z',
    updatedAt: '2026-09-17T11:00:00Z'
  },
  {
    id: 'proj-7707',
    sNo: '1008',
    dveplCode: '7707',
    orderConfirmDate: '2025-11-10',
    orderTakenBy: 'DINESH SIR',
    deliveryTarget: 'March 2026',
    concernedPerson: 'Vishal',
    concernedEmail: 'vishal@dvepl.com',
    partyName: 'SAGGI ELECTRIC CO',
    partyEmail: 'projects@saggielectric.com',
    caNumber: 'CE(AF)G_NLYA_OLD_26 OF 2024-2025_MES_722396_1',
    itemDescription: '12 Indoor Panels, LT Panels (13, 14, 15, 16, 17, 18, 29, 30, 31, 32, 33), APFC Panel 22, AMF Panels (3 Nos)',
    amount: 6240000,
    gst: 1123200,
    totalAmount: 7363200,
    advance: 700000,
    balance: 6663200,
    stage: 'Material Pending',
    priority: 'Critical',
    materialStatus: 'LK: 2000A 4P 50KA - 1 PC, 1000A 4P 50KA - 4 PC, 800A 4P 50KA - 2 PC on 15-09-26',
    vendorName: 'Lauritz Knudsen (LK / L&T)',
    vendorEmail: 'orders@lauritzknudsen.com',
    poNumber: '5394',
    poAmount: 2559489,
    drawingSendDate: '2026-01-30',
    drawingApprovedDate: '2026-08-01',
    remark: 'Reminder 2 mail sent on 31-07-26 of revise drawing. Drawing approved. Now expediting LK ACBs & MCCBs.',
    followUpCount: 4,
    lastFollowUpDate: '2026-09-15',
    nextFollowUpDate: '2026-09-21',
    autoFollowUpEnabled: true,
    followUpCadenceDays: 3,
    followUpHistory: [],
    milestones: [
      { id: 'm1', title: 'Drawing Approval', completed: true, completedAt: '2026-08-01', assignedTo: 'Vishal' },
      { id: 'm2', title: 'LK Material Delivery', completed: false, assignedTo: 'Dinesh Sir' },
      { id: 'm3', title: 'Fabrication', completed: true, completedAt: '2026-08-20', assignedTo: 'Arun' },
      { id: 'm4', title: 'Wiring & Testing', completed: false, assignedTo: 'Vishal' }
    ],
    createdAt: '2025-11-10T10:00:00Z',
    updatedAt: '2026-09-15T16:00:00Z'
  },
  {
    id: 'proj-7490',
    sNo: '1009',
    dveplCode: '7490',
    orderConfirmDate: '2025-12-10',
    orderTakenBy: 'DINESH SIR',
    deliveryTarget: 'April 2026',
    concernedPerson: 'Vishal',
    concernedEmail: 'vishal@dvepl.com',
    partyName: 'SAGGI ELECTRIC CO',
    partyEmail: 'projects@saggielectric.com',
    caNumber: 'CESZ_RANG_OF 2025-2026',
    itemDescription: 'Item 43 (6 Nos), LT Panel 44 (3 Nos), 45 (8 Nos), Feeder Pillar Boxes 46 (22 Nos), VCB-11KV 50 (1 No)',
    amount: 6542950,
    gst: 1177731,
    totalAmount: 7720681,
    advance: 650000,
    balance: 7070681,
    stage: 'Powder Coating',
    priority: 'High',
    materialStatus: 'SR 45 in Powder Coating on 07-08-26. SR 43, 44 in Powder Coating. LK PO 5532 pending on 15-09-26.',
    vendorName: 'Lauritz Knudsen (LK / L&T)',
    vendorEmail: 'orders@lauritzknudsen.com',
    poNumber: '5395 / 5532',
    poAmount: 1575346,
    drawingSendDate: '2026-01-28',
    drawingApprovedDate: '2026-03-15',
    remark: 'Drawing approved verbal. In powder coating & fabrication. Need LK PO delivery follow-up.',
    followUpCount: 5,
    lastFollowUpDate: '2026-09-15',
    nextFollowUpDate: '2026-09-20',
    autoFollowUpEnabled: true,
    followUpCadenceDays: 3,
    followUpHistory: [],
    milestones: [
      { id: 'm1', title: 'Drawing Approved', completed: true, completedAt: '2026-03-15', assignedTo: 'Vishal' },
      { id: 'm2', title: 'Fabrication Completed', completed: true, completedAt: '2026-07-20', assignedTo: 'Arun' },
      { id: 'm3', title: 'Powder Coating', completed: true, completedAt: '2026-08-15', assignedTo: 'Arun' },
      { id: 'm4', title: 'Electrical Busbar & Wiring', completed: false, assignedTo: 'Vishal' },
      { id: 'm5', title: 'Testing & Dispatch', completed: false, assignedTo: 'Lakhwinder' }
    ],
    createdAt: '2025-12-10T10:00:00Z',
    updatedAt: '2026-09-16T12:00:00Z'
  },
  {
    id: 'proj-7850',
    sNo: '1010',
    dveplCode: '7850',
    orderConfirmDate: '2025-12-10',
    orderTakenBy: 'DINESH SIR',
    deliveryTarget: 'April 2026',
    concernedPerson: 'Shobhit',
    concernedEmail: 'shobhit@dvepl.com',
    partyName: 'SAGGI ELECTRIC CO',
    partyEmail: 'projects@saggielectric.com',
    caNumber: 'CWE(AF)-PUR- OF 2025-2026 (PURNEA)',
    itemDescription: 'LT AND HT PANEL 13.69, HT VCB PANEL 13.5 (1 No), HT VCB PANEL 13.93 & 14.07, HT Control & Relay Panel',
    amount: 6843600,
    gst: 1231848,
    totalAmount: 8075448,
    advance: 650000,
    balance: 7425448,
    stage: 'Testing',
    priority: 'High',
    materialStatus: 'Almost ready, testing pending on 07-08-26. Order placed to BS Electric received. Unikon VCB received.',
    vendorName: 'Unikon Transformers',
    vendorEmail: 'sales@unikon.in',
    poNumber: '5461',
    poAmount: 307980,
    drawingSendDate: '2026-01-28',
    drawingApprovedDate: '2026-04-10',
    remark: 'Panel wiring almost completed, HV testing and relay calibration pending with Lakhwinder Sir.',
    followUpCount: 3,
    lastFollowUpDate: '2026-08-25',
    nextFollowUpDate: '2026-09-22',
    autoFollowUpEnabled: true,
    followUpCadenceDays: 4,
    followUpHistory: [],
    milestones: [
      { id: 'm1', title: 'Drawing Approval', completed: true, completedAt: '2026-04-10', assignedTo: 'Shobhit' },
      { id: 'm2', title: 'Fabrication & Powder Coating', completed: true, completedAt: '2026-06-15', assignedTo: 'Arun' },
      { id: 'm3', title: 'HT VCB Wiring & Busbar', completed: true, completedAt: '2026-08-01', assignedTo: 'Shobhit' },
      { id: 'm4', title: 'Relay & Breaker Testing', completed: false, assignedTo: 'Lakhwinder' },
      { id: 'm5', title: 'Customer Inspection & Dispatch', completed: false, assignedTo: 'Dinesh Sir' }
    ],
    createdAt: '2025-12-10T10:00:00Z',
    updatedAt: '2026-09-17T15:00:00Z'
  },
  {
    id: 'proj-7877',
    sNo: '1025',
    dveplCode: '7877',
    orderConfirmDate: '2025-12-01',
    orderTakenBy: 'DINESH SIR',
    deliveryTarget: 'April 2026',
    concernedPerson: 'Vishal',
    concernedEmail: 'vishal@dvepl.com',
    partyName: 'DHAULADHAR RESORT PVT. LTD. (HOTEL TAJ)',
    partyEmail: 'project.head@dhauladharresort.com',
    caNumber: 'PRIVATE - HOTEL TAJ DHARAMSHALA',
    itemDescription: 'MAIN LT PANEL TTA, Capacitor Bank Panel (315kVAR TTA), Lift Panel, EV Charging Panel, UPS O/G Panels',
    amount: 7000000,
    gst: 1260000,
    totalAmount: 8260000,
    advance: 0,
    balance: 8260000,
    stage: 'Electrical Wiring',
    priority: 'Critical',
    materialStatus: 'Schneider CVS 400S links received. 6 panels dispatched on 02-09-26. 2 Capacitor APFC panels pending.',
    vendorName: 'Schneider Electric',
    vendorEmail: 'orders.india@se.com',
    poNumber: '5368',
    poAmount: 3105904,
    drawingSendDate: '2026-01-10',
    drawingApprovedDate: '2026-02-15',
    remark: '6 panels dispatched on 02-09-26. Remaining APFC capacitor panels in electrical wiring on 31-08-26.',
    followUpCount: 6,
    lastFollowUpDate: '2026-09-02',
    nextFollowUpDate: '2026-09-20',
    autoFollowUpEnabled: true,
    followUpCadenceDays: 3,
    followUpHistory: [],
    milestones: [
      { id: 'm1', title: 'Drawing Approval', completed: true, completedAt: '2026-02-15', assignedTo: 'Vishal' },
      { id: 'm2', title: 'Main LT Panel Dispatch', completed: true, completedAt: '2026-09-02', assignedTo: 'Lakhwinder' },
      { id: 'm3', title: 'Capacitor Bank Panel Assembly', completed: false, assignedTo: 'Vishal' },
      { id: 'm4', title: 'Balance Dispatch & Payment', completed: false, assignedTo: 'Dinesh Sir' }
    ],
    createdAt: '2025-12-01T10:00:00Z',
    updatedAt: '2026-09-18T10:00:00Z'
  },
  {
    id: 'proj-8057',
    sNo: '8057',
    dveplCode: '8057',
    orderConfirmDate: '2026-02-02',
    orderTakenBy: 'DINESH SIR',
    deliveryTarget: 'May 2026',
    concernedPerson: 'Vishal',
    concernedEmail: 'vishal@dvepl.com',
    partyName: 'THE MATTEWAL CO-OP SOCIETY LTD',
    partyEmail: 'mattewal.society@gmail.com',
    caNumber: 'SRNO-34.23A',
    itemDescription: 'MAIN LT PANEL, Capacitor Panel 225kVAR (TTA), Feeder panels (5 Nos)',
    amount: 1780700,
    gst: 320526,
    totalAmount: 2101226,
    advance: 0,
    balance: 2101226,
    stage: 'Electrical Wiring',
    priority: 'High',
    materialStatus: '8 panels dispatched on 27-08-26. TTA panel in electrical progress on 31-08-26. Indo Asian PO 5473 ok.',
    vendorName: 'IndoAsian',
    vendorEmail: 'support@indoasian.com',
    poNumber: '5473 / 5489',
    poAmount: 647383,
    drawingSendDate: '2026-02-16',
    drawingApprovedDate: '2026-04-15',
    remark: '8 panels dispatched on 27-08-26. TTA panel assembly in progress. Final inspection next week.',
    followUpCount: 4,
    lastFollowUpDate: '2026-08-27',
    nextFollowUpDate: '2026-09-21',
    autoFollowUpEnabled: true,
    followUpCadenceDays: 4,
    followUpHistory: [],
    milestones: [
      { id: 'm1', title: 'Drawing Approved', completed: true, completedAt: '2026-04-15', assignedTo: 'Vishal' },
      { id: 'm2', title: 'Part Dispatch (8 Panels)', completed: true, completedAt: '2026-08-27', assignedTo: 'Lakhwinder' },
      { id: 'm3', title: 'TTA Panel Wiring', completed: false, assignedTo: 'Vishal' }
    ],
    createdAt: '2026-02-02T10:00:00Z',
    updatedAt: '2026-09-16T14:00:00Z'
  },
  {
    id: 'proj-7989',
    sNo: '7989',
    dveplCode: '7989',
    orderConfirmDate: '2026-03-17',
    orderTakenBy: 'Dinesh Sir',
    deliveryTarget: 'May 2026',
    concernedPerson: 'Vishal',
    concernedEmail: 'vishal@dvepl.com',
    partyName: 'VIJAY BUILDERS',
    partyEmail: 'vijaybuilders.mes@yahoo.co.in',
    caNumber: 'CA.NO-87985-A_E8',
    itemDescription: 'LT PANEL - SR.NO 26 (1 No), SR.NO 27 (4 Nos), SR.NO 22 (4 Nos)',
    amount: 3300600,
    gst: 594108,
    totalAmount: 3894708,
    advance: 300000,
    balance: 3594708,
    stage: 'Electrical Wiring',
    priority: 'High',
    materialStatus: 'In elec process 31-08-26. 2 ACB 2000 AMP - 1 PC pending from LK on 15-09-26.',
    vendorName: 'Lauritz Knudsen (LK / L&T)',
    vendorEmail: 'orders@lauritzknudsen.com',
    poNumber: '5468',
    poAmount: 1615861,
    drawingSendDate: '2026-04-15',
    drawingApprovedDate: '2026-06-01',
    remark: 'In electrical assembly. 1 ACB pending from LK. Need urgent vendor reminder on PO 5468.',
    followUpCount: 4,
    lastFollowUpDate: '2026-09-15',
    nextFollowUpDate: '2026-09-20',
    autoFollowUpEnabled: true,
    followUpCadenceDays: 3,
    followUpHistory: [],
    milestones: [
      { id: 'm1', title: 'Drawing Approved', completed: true, completedAt: '2026-06-01', assignedTo: 'Vishal' },
      { id: 'm2', title: 'Fabrication & Powder Coating', completed: true, completedAt: '2026-08-10', assignedTo: 'Arun' },
      { id: 'm3', title: 'Receive 2000A ACB from LK', completed: false, assignedTo: 'Dinesh Sir' },
      { id: 'm4', title: 'Final Wiring & Busbar', completed: false, assignedTo: 'Vishal' }
    ],
    createdAt: '2026-03-17T10:00:00Z',
    updatedAt: '2026-09-18T09:00:00Z'
  },
  {
    id: 'proj-8307',
    sNo: '8307',
    dveplCode: '8307',
    orderConfirmDate: '2026-04-20',
    orderTakenBy: 'DINESH SIR',
    deliveryTarget: 'July 2026',
    concernedPerson: 'Vishal',
    concernedEmail: 'vishal@dvepl.com',
    partyName: 'SATISH & CO',
    partyEmail: 'satishcompany.kpdcl@rediffmail.com',
    caNumber: 'KPDCL PROJECT',
    itemDescription: 'SRNO-1 (5 Nos), SRNO-2 (50 Nos Outdoor LT Panels), SRNO-3 (2 Nos Indoor LT Panels)',
    amount: 410000,
    gst: 73800,
    totalAmount: 483800,
    advance: 0,
    balance: 483800,
    stage: 'Electrical Wiring',
    priority: 'Medium',
    materialStatus: 'HPL PO 5518: PO OK on 15-09-26. Reminder mail sent on 23-07-26 about pending PO. In electrical process 31-08-26.',
    vendorName: 'HPL Electric',
    vendorEmail: 'delhi.sales@hplindia.com',
    poNumber: '5518',
    poAmount: 180000,
    drawingSendDate: '2026-05-07',
    drawingApprovedDate: '2026-06-25',
    remark: '50 outdoor panels in electrical wiring. 2 indoor panels fabrication done. HPL PO received.',
    followUpCount: 3,
    lastFollowUpDate: '2026-07-23',
    nextFollowUpDate: '2026-09-22',
    autoFollowUpEnabled: true,
    followUpCadenceDays: 5,
    followUpHistory: [],
    milestones: [
      { id: 'm1', title: 'Drawing Approved', completed: true, completedAt: '2026-06-25', assignedTo: 'Vishal' },
      { id: 'm2', title: 'Fabrication of 52 Panels', completed: true, completedAt: '2026-08-15', assignedTo: 'Arun' },
      { id: 'm3', title: 'Electrical Wiring & Busbar', completed: false, assignedTo: 'Vishal' }
    ],
    createdAt: '2026-04-20T10:00:00Z',
    updatedAt: '2026-09-17T14:00:00Z'
  },
  {
    id: 'proj-8118',
    sNo: '8118',
    dveplCode: '8118',
    orderConfirmDate: '2026-07-18',
    orderTakenBy: 'PRERNA',
    deliveryTarget: 'September 2026',
    concernedPerson: 'Vishal',
    concernedEmail: 'vishal@dvepl.com',
    partyName: 'SATISH & COMPANY',
    partyEmail: 'satishcompany.kpdcl@rediffmail.com',
    caNumber: 'TPKEN-17_ 2025-2026',
    itemDescription: 'VCB (5 Nos), LBS (3 Nos), LT Panels 29, 30, 31, 32, 33, 34, 35, 36, 37',
    amount: 3930797,
    gst: 707543.46,
    totalAmount: 4638340.46,
    advance: 80800,
    balance: 4557540.46,
    stage: 'Drawing Approval Pending',
    priority: 'Critical',
    materialStatus: 'Havells PO 5548: 656485. Not received yet on 15-09-26. Drawing sent on 10-09-26.',
    vendorName: 'Havells',
    vendorEmail: 'switchgear.orders@havells.com',
    poNumber: '5548',
    poAmount: 656485,
    drawingSendDate: '2026-08-11',
    remark: 'Revised drawing sent for approval on 10-09-26. Approval pending. Havells material pending.',
    followUpCount: 2,
    lastFollowUpDate: '2026-09-10',
    nextFollowUpDate: '2026-09-19',
    autoFollowUpEnabled: true,
    followUpCadenceDays: 2,
    followUpHistory: [],
    milestones: [
      { id: 'm1', title: 'Drawing Revision Sent', completed: true, completedAt: '2026-09-10', assignedTo: 'Vishal' },
      { id: 'm2', title: 'Drawing Approval from Satish & Co', completed: false, assignedTo: 'Vishal' },
      { id: 'm3', title: 'Havells PO Material Delivery', completed: false, assignedTo: 'Prerna' }
    ],
    createdAt: '2026-07-18T10:00:00Z',
    updatedAt: '2026-09-18T11:00:00Z'
  },
  {
    id: 'proj-8296',
    sNo: '8296',
    dveplCode: '8296',
    orderConfirmDate: '2026-01-31',
    orderTakenBy: 'IQBAL SIR',
    deliveryTarget: '45 to 60 days after approval',
    concernedPerson: 'Vishal',
    concernedEmail: 'vishal@dvepl.com',
    partyName: 'SURINDER KUMAR MAHAJAN (JANDIYAL)',
    partyEmail: 'skmahajan.contractor@gmail.com',
    caNumber: 'CWE (A) JODH_BNR‐ OF 2026‐27',
    itemDescription: 'Panels SRNO-24 (160 Nos), SRNO-30 through SRNO-62 (32 Panels)',
    amount: 2029968,
    gst: 365434.36,
    totalAmount: 2395402.36,
    advance: 150000,
    balance: 2245402.36,
    stage: 'Drawing Approval Pending',
    priority: 'High',
    materialStatus: 'HPL PO 5550 (Rs 5,77,134) - PO not received yet on 15-09-26. Drawing sent 07-09-26.',
    vendorName: 'HPL Electric',
    vendorEmail: 'delhi.sales@hplindia.com',
    poNumber: '5550',
    poAmount: 577134,
    drawingSendDate: '2026-09-07',
    remark: 'Drawing sent on 07-09-26, approval pending from Jandiyal. Follow-up needed.',
    followUpCount: 1,
    lastFollowUpDate: '2026-09-07',
    nextFollowUpDate: '2026-09-19',
    autoFollowUpEnabled: true,
    followUpCadenceDays: 3,
    followUpHistory: [],
    milestones: [
      { id: 'm1', title: 'Drawing Sent to Jandiyal', completed: true, completedAt: '2026-09-07', assignedTo: 'Vishal' },
      { id: 'm2', title: 'Drawing Approval from Client', completed: false, assignedTo: 'Vishal' },
      { id: 'm3', title: 'HPL Material PO Follow-up', completed: false, assignedTo: 'Iqbal Sir' }
    ],
    createdAt: '2026-01-31T10:00:00Z',
    updatedAt: '2026-09-17T16:00:00Z'
  },
  {
    id: 'proj-8489',
    sNo: '8489',
    dveplCode: '8489',
    orderConfirmDate: '2026-09-04',
    orderTakenBy: 'DEEPANSHU',
    deliveryTarget: '45 to 60 days after approval',
    concernedPerson: 'Vishal',
    concernedEmail: 'vishal@dvepl.com',
    partyName: 'RAJNISH DUGGAL',
    partyEmail: 'rajnish.duggal.mes@gmail.com',
    caNumber: 'MES - sr no 2.01, 2.02, 2.03, 65',
    itemDescription: 'sr no 2.01 (2 Nos), sr no 2.02 (2 Nos), s.no 2.03 (1 No), sr no 65 (4 Nos)',
    amount: 570000,
    gst: 102600,
    totalAmount: 672600,
    advance: 0,
    balance: 672600,
    stage: 'Drawing in Process',
    priority: 'Medium',
    materialStatus: 'Havells PO 5554 (Rs 2,73,253) placed 05-09-26. 8 items pending on 15-09-26.',
    vendorName: 'Havells',
    vendorEmail: 'switchgear.orders@havells.com',
    poNumber: '5554',
    poAmount: 273253,
    drawingSendDate: '2026-09-18',
    remark: 'Drawing target 18-09-2026. Havells PO placed, 8 items pending delivery.',
    followUpCount: 0,
    autoFollowUpEnabled: true,
    followUpCadenceDays: 3,
    followUpHistory: [],
    milestones: [
      { id: 'm1', title: 'Drawing Preparation by Vishal', completed: true, completedAt: '2026-09-18', assignedTo: 'Vishal' },
      { id: 'm2', title: 'Submission to Rajnish Duggal', completed: false, assignedTo: 'Vishal' },
      { id: 'm3', title: 'Havells Component Delivery', completed: false, assignedTo: 'Deepanshu' }
    ],
    createdAt: '2026-09-04T10:00:00Z',
    updatedAt: '2026-09-18T15:00:00Z'
  },
  {
    id: 'proj-8569',
    sNo: '8569',
    dveplCode: '8569',
    orderConfirmDate: '2026-09-05',
    orderTakenBy: 'ARUN',
    deliveryTarget: '45 to 60 days after approval',
    concernedPerson: 'Vishal',
    concernedEmail: 'vishal@dvepl.com',
    partyName: 'SHAKTI PUMP',
    partyEmail: 'procurement@shaktipumps.co.in',
    caNumber: 'PVT - SHAKTI PUMP',
    itemDescription: 'Main LT Panel (1 No), APFC Panel (1 No), Distribution Panel (1 No)',
    amount: 240000,
    gst: 43082,
    totalAmount: 283082,
    advance: 0,
    balance: 283082,
    stage: 'Drawing Sent',
    priority: 'Medium',
    materialStatus: 'Drawing sent for approval on 18-09-26. Material to be ordered post approval.',
    vendorName: '',
    drawingSendDate: '2026-09-18',
    remark: 'Drawing sent 18-09-26. Follow-up for approval scheduled for 21-09-26.',
    followUpCount: 0,
    nextFollowUpDate: '2026-09-21',
    autoFollowUpEnabled: true,
    followUpCadenceDays: 3,
    followUpHistory: [],
    milestones: [
      { id: 'm1', title: 'Drawing Created', completed: true, completedAt: '2026-09-10', assignedTo: 'Vishal' },
      { id: 'm2', title: 'Drawing Sent to Client', completed: true, completedAt: '2026-09-18', assignedTo: 'Arun' },
      { id: 'm3', title: 'Client Approval', completed: false, assignedTo: 'Arun' }
    ],
    createdAt: '2026-09-05T10:00:00Z',
    updatedAt: '2026-09-18T16:00:00Z'
  },
  {
    id: 'proj-6728',
    sNo: '998',
    dveplCode: '6728',
    orderConfirmDate: '2025-09-15',
    orderTakenBy: 'DINESH SIR',
    deliveryTarget: 'Offline (Pankaj Engg)',
    concernedPerson: 'Vishal',
    concernedEmail: 'vishal@dvepl.com',
    partyName: 'BEST WESTERN_GSP_GOLDEN VILLAS',
    partyEmail: 'gm@bestwesterngoldenvillas.com',
    caNumber: 'BEST WESTERN - 6728',
    itemDescription: 'Main Panel, Landscape Panel, IT Room Panel, AC Panel-1, Floor Panels, VCB Panel, Capacitor Bank (300kVAR)',
    amount: 2634698,
    gst: 474245.64,
    totalAmount: 3108943.64,
    advance: 0,
    balance: 3108943.64,
    stage: 'Powder Coating',
    priority: 'High',
    materialStatus: 'AC Panel dispatched. 1 Main Panel pending in powder coating process on 31-08-26.',
    vendorName: 'Schneider Electric',
    drawingSendDate: '2025-10-15',
    drawingApprovedDate: '2025-11-04',
    remark: 'AC Panel dispatched. Main Panel in powder coating. Need dispatch intimation once packed.',
    followUpCount: 3,
    lastFollowUpDate: '2026-08-31',
    nextFollowUpDate: '2026-09-20',
    autoFollowUpEnabled: true,
    followUpCadenceDays: 4,
    followUpHistory: [],
    milestones: [
      { id: 'm1', title: 'Drawing Approved', completed: true, completedAt: '2025-11-04', assignedTo: 'Vishal' },
      { id: 'm2', title: 'AC Panel Dispatch', completed: true, completedAt: '2026-07-15', assignedTo: 'Lakhwinder' },
      { id: 'm3', title: 'Main Panel Powder Coating', completed: false, assignedTo: 'Arun' },
      { id: 'm4', title: 'Wiring & Testing', completed: false, assignedTo: 'Vishal' }
    ],
    createdAt: '2025-09-15T10:00:00Z',
    updatedAt: '2026-09-16T10:00:00Z'
  },
  {
    id: 'proj-6840',
    sNo: '1001',
    dveplCode: '6840',
    orderConfirmDate: '2025-11-13',
    orderTakenBy: 'DINESH SIR',
    deliveryTarget: 'February 2026',
    concernedPerson: 'Vishal',
    concernedEmail: 'vishal@dvepl.com',
    partyName: 'MARIB CONSTRUCTION (MR ALI / JAVED)',
    partyEmail: 'marib.construction@gmail.com',
    caNumber: 'LT PANEL & DG PANEL',
    itemDescription: 'LT Panel (1 No), DG Panel (1 No)',
    amount: 818000,
    gst: 147240,
    totalAmount: 965240,
    advance: 0,
    balance: 965240,
    stage: 'Fabrication',
    priority: 'Medium',
    materialStatus: 'Drawing approved 06-08-26. Sent to production with Akshay for nesting.',
    vendorName: 'Havells',
    drawingSendDate: '2025-11-13',
    drawingApprovedDate: '2026-08-06',
    remark: 'Sent to production with Akshay for sheet metal nesting. Material from party pending.',
    followUpCount: 2,
    lastFollowUpDate: '2026-08-06',
    nextFollowUpDate: '2026-09-22',
    autoFollowUpEnabled: true,
    followUpCadenceDays: 5,
    followUpHistory: [],
    milestones: [
      { id: 'm1', title: 'Drawing Approved', completed: true, completedAt: '2026-08-06', assignedTo: 'Vishal' },
      { id: 'm2', title: 'CNC Nesting & Punching', completed: true, completedAt: '2026-08-25', assignedTo: 'Akshay' },
      { id: 'm3', title: 'Bending & Fabrication', completed: false, assignedTo: 'Arun' }
    ],
    createdAt: '2025-11-13T10:00:00Z',
    updatedAt: '2026-09-15T11:00:00Z'
  },
  {
    id: 'proj-6071',
    sNo: '6071',
    dveplCode: '6071',
    orderConfirmDate: '2026-06-19',
    orderTakenBy: 'IQBAL SIR',
    deliveryTarget: '45-60 Days after approval',
    concernedPerson: 'Vishal',
    concernedEmail: 'vishal@dvepl.com',
    partyName: 'M/S NAFREF ENGINEERS PRVT LTD',
    partyEmail: 'nafref.engineers@yahoo.com',
    caNumber: 'CE RND_DLI-33_DLI_2023-2024 (MES 629421)',
    itemDescription: '11 Panel items: SR NO 56, 66, 68, 70, 72, 86, 143, 265, 266, 267, 268',
    amount: 5700000,
    gst: 1026000,
    totalAmount: 6726000,
    advance: 500000,
    balance: 6226000,
    stage: 'Drawing Approval Pending',
    priority: 'Critical',
    materialStatus: 'LK PO 5553 (Rs 34,62,684) - PO not received yet on 15-09-26. Payment and approval pending.',
    vendorName: 'Lauritz Knudsen (LK / L&T)',
    vendorEmail: 'orders@lauritzknudsen.com',
    poNumber: '5553',
    poAmount: 3462684,
    drawingSendDate: '2026-09-04',
    remark: 'Drawing sent for approval 04-09-26. Client payment and drawing approval pending.',
    followUpCount: 2,
    lastFollowUpDate: '2026-09-12',
    nextFollowUpDate: '2026-09-19',
    autoFollowUpEnabled: true,
    followUpCadenceDays: 3,
    followUpHistory: [],
    milestones: [
      { id: 'm1', title: 'Drawing Sent', completed: true, completedAt: '2026-09-04', assignedTo: 'Vishal' },
      { id: 'm2', title: 'Approval from Nafref Engineers', completed: false, assignedTo: 'Vishal' },
      { id: 'm3', title: 'Advance Payment Collection', completed: false, assignedTo: 'Iqbal Sir' },
      { id: 'm4', title: 'Confirm LK Switchgear PO', completed: false, assignedTo: 'Dinesh Sir' }
    ],
    createdAt: '2026-06-19T10:00:00Z',
    updatedAt: '2026-09-18T17:00:00Z'
  },
  {
    id: 'proj-7714',
    sNo: '1013',
    dveplCode: '7714',
    orderConfirmDate: '2025-12-20',
    orderTakenBy: 'DINESH SIR',
    deliveryTarget: 'May 2026',
    concernedPerson: 'Arun',
    concernedEmail: 'arun@dvepl.com',
    partyName: 'VISHAL DOGRA',
    partyEmail: 'vishal.dogra.school@gmail.com',
    caNumber: 'ANGLE SCHOOL',
    itemDescription: 'Main LT Panel (1 No)',
    amount: 80000,
    gst: 14400,
    totalAmount: 94400,
    advance: 0,
    balance: 94400,
    stage: 'Case on Hold',
    priority: 'Low',
    materialStatus: 'Material from party placed. Panel on hold as per Dinesh Sir.',
    vendorName: 'Party Material',
    drawingSendDate: '2025-12-20',
    remark: 'Panel on hold as per Dinesh Sir. Discuss before releasing to shop floor.',
    followUpCount: 1,
    lastFollowUpDate: '2026-05-10',
    autoFollowUpEnabled: false,
    followUpCadenceDays: 7,
    followUpHistory: [],
    milestones: [
      { id: 'm1', title: 'Drawing Prepared by Arun', completed: true, completedAt: '2025-12-20', assignedTo: 'Arun' },
      { id: 'm2', title: 'Hold Status Review with Dinesh Sir', completed: false, assignedTo: 'Arun' }
    ],
    createdAt: '2025-12-20T10:00:00Z',
    updatedAt: '2026-08-10T12:00:00Z'
  },
  {
    id: 'proj-6408',
    sNo: '736',
    dveplCode: '6408',
    orderConfirmDate: '2024-06-29',
    orderTakenBy: 'DINESH SIR',
    deliveryTarget: 'Completed',
    concernedPerson: 'Akshay',
    concernedEmail: 'akshay@dvepl.com',
    partyName: 'JAIVEER KANG',
    partyEmail: 'jaiveer.kang.contractor@gmail.com',
    caNumber: 'PHE/ENIT 157 OF 2022-23',
    itemDescription: 'Panel Item 1 (1 No)',
    amount: 110000,
    gst: 19800,
    totalAmount: 129800,
    advance: 129800,
    balance: 0,
    stage: 'Dispatched',
    priority: 'Low',
    materialStatus: 'Complete & Dispatched',
    vendorName: 'L&T',
    remark: 'Successfully dispatched.',
    followUpCount: 1,
    autoFollowUpEnabled: false,
    followUpCadenceDays: 7,
    followUpHistory: [],
    milestones: [
      { id: 'm1', title: 'Production & Testing', completed: true, completedAt: '2024-08-10', assignedTo: 'Akshay' },
      { id: 'm2', title: 'Final Dispatch', completed: true, completedAt: '2024-08-20', assignedTo: 'Lakhwinder' }
    ],
    createdAt: '2024-06-29T10:00:00Z',
    updatedAt: '2024-08-20T10:00:00Z'
  }
];
